import { DuplicateRowsComponentProps, IndicatorFactorsPicker } from 'app/area/indicator-factors/types';

export const getParametersId = (props: DuplicateRowsComponentProps) => props.validation?.code?.messages[0]?.parameters?.id;

export const hasFieldValueChanged = (prevProps: DuplicateRowsComponentProps, props: DuplicateRowsComponentProps) => {
  const previousForm = prevProps?.list?.duplicateRows?.form ?? {};
  const currentForm = props?.list?.duplicateRows?.form ?? {};

  return Object.keys(IndicatorFactorsPicker)
    .some(field => currentForm[field] !== previousForm[field]);
};

export const allFieldsEmpty = (props: DuplicateRowsComponentProps) => {
  const duplicateRowsFields = Object.keys(IndicatorFactorsPicker);
  const duplicateRows = props?.list?.duplicateRows?.form ?? {};

  return duplicateRowsFields.map(item => duplicateRows[item]).filter(f => !!f)?.length === 0;
};

export const isDisabled = (props: DuplicateRowsComponentProps) => {
  const duplicateRowsFields = Object.keys(IndicatorFactorsPicker);
  const duplicateRows = props?.list?.duplicateRows;
  const fieldsError = duplicateRows?.validation
    && duplicateRowsFields.map(item => duplicateRows?.form[item] && duplicateRows?.validation[item]).filter(f => !!f);

  return fieldsError?.length > 0 && !duplicateRows?.isDirty;
};
